import { useState } from "react";
import getclassNames from "../../utils/getClassNames";
import './Tabs.css';

interface TabsProps {
    children: JSX.Element[];
}

const getTabTestIdSuffix = (title: string) =>
    title.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const Tabs = (props: TabsProps) => {
    const tabs = props.children.filter(c => c);

    const [activeIndex, setActiveIndex] = useState(0);
    return (<div className="tab-container">
        <div className="tab-headers">
            {tabs.map((tab, i) => {
                const testIdSuffix = getTabTestIdSuffix(tab.props.title);
                return <div
                    key={`${tab.props.title}-${i}`}
                    tabIndex={-1}
                    data-testid={`tab-header-${testIdSuffix}`}
                    className={getclassNames('tab-header', i === activeIndex ? 'active' : '')}
                    onClick={() => setActiveIndex(i)}>
                    {tab.props.title}
                </div>
            })}
        </div>
        <div className="tab-body">
            {tabs.map((tab, i) => {
                const testIdSuffix = getTabTestIdSuffix(tab.props.title);
                return <div
                    key={i}
                    data-testid={`tab-panel-${testIdSuffix}`}
                    className={getclassNames('tab-content', i !== activeIndex ? 'hidden' : '')}>
                    {tab}
                </div>
            })}
        </div>
    </div>)
};

export default Tabs;
